module.exports = __webpack_public_path__ + "img/loading.79741e63.svg";